// import { Box, Container, Typography } from "@mui/material";
// import { motion } from "framer-motion";

// /* ───────────────── Fonts ───────────────── */
// const FontImport = () => (
//   <style>{`
//     @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
//   `}</style>
// );

// /* ───────────────── Data ───────────────── */
// const RECOGNITIONS = [
//   {
//     name: "Startup India",
//     tag: "Government Recognition",
//   },
//   {
//     name: "Startup Karnataka",
//     tag: "Innovation Ecosystem",
//   },
//   {
//     name: "Silicon India",
//     tag: "Media Recognition",
//   },
// ];

// /* ───────────────── Animation ───────────────── */
// const fadeUp = (delay = 0) => ({
//   initial: {
//     opacity: 0,
//     y: 20,
//   },

//   whileInView: {
//     opacity: 1,
//     y: 0,
//   },

//   viewport: {
//     once: true,
//   },

//   transition: {
//     duration: 0.65,
//     delay,
//     ease: [0.22, 1, 0.36, 1],
//   },
// });

// /* ───────────────── Main Component ───────────────── */
// export default function RecognizedBy() {
//   return (
//     <>
//       <FontImport />

//       <Box
//         component="section"
//         sx={{
//           position: "relative",
//           overflow: "hidden",
//           background: "#000000",

//           py: {
//             xs: 10,
//             md: 14,
//           },
//         }}
//       >
//         {/* top separator */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: "50%",
//             transform: "translateX(-50%)",

//             width: {
//               xs: "82%",
//               md: "60%",
//             },

//             height: "1px",

//             background:
//               "linear-gradient(to right, transparent, rgba(30,144,255,.18), transparent)",
//           }}
//         />

//         {/* ambient blue glow */}
//         <Box
//           component={motion.div}
//           animate={{
//             scale: [1, 1.08, 1],
//             opacity: [0.3, 0.6, 0.3],
//           }}
//           transition={{
//             duration: 7,
//             repeat: Infinity,
//             ease: "easeInOut",
//           }}
//           sx={{
//             position: "absolute",

//             width: {
//               xs: 260,
//               md: 520,
//             },

//             height: {
//               xs: 260,
//               md: 520,
//             },

//             borderRadius: "50%",

//             background:
//               "radial-gradient(circle, rgba(30,144,255,.12), transparent 70%)",

//             top: "-15%",
//             left: "50%",

//             transform:
//               "translateX(-50%)",

//             filter: "blur(90px)",

//             pointerEvents: "none",
//           }}
//         />

//         <Container
//           maxWidth="lg"
//           sx={{
//             position: "relative",
//             zIndex: 2,
//           }}
//         >
//           {/* heading */}
//           <Box
//             sx={{
//               textAlign: "center",

//               mb: {
//                 xs: 5,
//                 md: 7,
//               },
//             }}
//           >
//             <motion.div {...fadeUp(0)}>
//               <Box
//                 sx={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 1.2,
//                   mb: 3,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     width: 18,
//                     height: "1px",
//                     background:
//                       "rgba(30,144,255,.6)",
//                   }}
//                 />

//                 <Typography
//                   sx={{
//                     fontFamily:
//                       "'DM Sans', sans-serif",

//                     fontSize: ".72rem",

//                     fontWeight: 700,

//                     color:
//                       "rgba(88,178,255,.92)",

//                     letterSpacing: ".14em",

//                     textTransform:
//                       "uppercase",
//                   }}
//                 >
//                   Recognized By
//                 </Typography>

//                 <Box
//                   sx={{
//                     width: 18,
//                     height: "1px",
//                     background:
//                       "rgba(30,144,255,.6)",
//                   }}
//                 />
//               </Box>
//             </motion.div>

//             <motion.div {...fadeUp(0.08)}>
//               <Typography
//                 sx={{
//                   fontFamily:
//                     "'Bricolage Grotesque', sans-serif",

//                   fontWeight: 750,

//                   lineHeight: 1.05,

//                   letterSpacing: "-0.05em",

//                   color: "#FFFFFF",

//                   fontSize: {
//                     xs: "2rem",
//                     sm: "2.5rem",
//                     md: "3.5rem",
//                   },

//                   mb: 2,
//                 }}
//               >
//                 Recognized across

//                 <br />

//                 <Box
//                   component="span"
//                   sx={{
//                     background:
//                       "linear-gradient(90deg,#1E90FF 0%,#63B8FF 55%,#BFE3FF 100%)",

//                     WebkitBackgroundClip:
//                       "text",

//                     WebkitTextFillColor:
//                       "transparent",
//                   }}
//                 >
//                   India’s innovation ecosystem
//                 </Box>
//               </Typography>
//             </motion.div>

//             <motion.div {...fadeUp(0.15)}>
//               <Typography
//                 sx={{
//                   maxWidth: "620px",

//                   mx: "auto",

//                   fontFamily:
//                     "'DM Sans', sans-serif",

//                   fontSize: {
//                     xs: ".95rem",
//                     md: "1rem",
//                   },

//                   lineHeight: 1.9,

//                   color:
//                     "rgba(210,230,255,.7)",
//                 }}
//               >
//                 Supported and acknowledged by leading startup,
// innovation, and technology platforms driving
// next-generation entrepreneurship.
//               </Typography>
//             </motion.div>
//           </Box>

//           {/* recognition cards */}
//           <Box
//             sx={{
//               display: "grid",

//               gridTemplateColumns: {
//                 xs: "1fr",
//                 sm: "repeat(2,1fr)",
//                 md: "repeat(3,1fr)",
//               },

//               gap: {
//                 xs: 2,
//                 md: 3,
//               },
//             }}
//           >
//             {RECOGNITIONS.map(
//               (item, index) => (
//                 <Box
//                   key={item.name}
//                   component={motion.div}
//                   initial={{
//                     opacity: 0,
//                     y: 20,
//                   }}
//                   whileInView={{
//                     opacity: 1,
//                     y: 0,
//                   }}
//                   viewport={{
//                     once: true,
//                   }}
//                   transition={{
//                     duration: 0.55,
//                     delay:
//                       index * 0.08,
//                   }}
//                   whileHover={{
//                     y: -4,
//                     scale: 1.02,
//                   }}
//                   sx={{
//                     position: "relative",

//                     overflow: "hidden",

//                     borderRadius:
//                       "22px",

//                     p: {
//                       xs: 3,
//                       md: 4,
//                     },

//                     background:
//                       "rgba(10,10,10,.92)",

//                     border:
//                       "1px solid rgba(30,144,255,.16)",

//                     backdropFilter:
//                       "blur(16px)",

//                     boxShadow:
//                       "inset 0 1px 0 rgba(255,255,255,.03)",

//                     transition:
//                       ".3s ease",

//                     "&:hover": {
//                       borderColor:
//                         "rgba(30,144,255,.35)",

//                       boxShadow:
//                         "0 10px 40px rgba(30,144,255,.15), inset 0 1px 0 rgba(255,255,255,.06)",
//                     },
//                   }}
//                 >
//                   {/* glow */}
//                   <Box
//                     sx={{
//                       position:
//                         "absolute",

//                       width: 160,

//                       height: 160,

//                       borderRadius:
//                         "50%",

//                       background:
//                         "radial-gradient(circle, rgba(30,144,255,.14), transparent 70%)",

//                       top: -80,
//                       right: -80,
//                     }}
//                   />

//                   {/* logo placeholder */}
//                   <Box
//                     sx={{
//                       width: 52,
//                       height: 52,

//                       borderRadius:
//                         "14px",

//                       display: "flex",

//                       alignItems:
//                         "center",

//                       justifyContent:
//                         "center",

//                       mb: 3,

//                       background:
//                         "rgba(30,144,255,.08)",

//                       border:
//                         "1px solid rgba(30,144,255,.2)",

//                       color:
//                         "#63B8FF",

//                       fontFamily:
//                         "'Bricolage Grotesque', sans-serif",

//                       fontWeight: 700,

//                       fontSize:
//                         "1rem",
//                     }}
//                   >
//                     {item.name
//                       .split(" ")
//                       .map(
//                         (w) => w[0]
//                       )
//                       .join("")}
//                   </Box>

//                   {/* title */}
//                   <Typography
//                     sx={{
//                       fontFamily:
//                         "'Bricolage Grotesque', sans-serif",

//                       fontWeight: 700,

//                       color:
//                         "#FFFFFF",

//                       fontSize: {
//                         xs: "1rem",
//                         md: "1.15rem",
//                       },

//                       mb: 1.2,
//                     }}
//                   >
//                     {item.name}
//                   </Typography>

//                   {/* tag */}
//                   <Typography
//                     sx={{
//                       fontFamily:
//                         "'DM Sans', sans-serif",

//                       color:
//                         "rgba(210,230,255,.68)",

//                       fontSize:
//                         ".9rem",

//                       lineHeight: 1.7,
//                     }}
//                   >
//                     {item.tag}
//                   </Typography>
//                 </Box>
//               )
//             )}
//           </Box>
//         </Container>

//         {/* bottom separator */}
//         <Box
//           sx={{
//             position: "absolute",
//             bottom: 0,
//             left: "50%",
//             transform: "translateX(-50%)",

//             width: {
//               xs: "82%",
//               md: "60%",
//             },

//             height: "1px",

//             background:
//               "linear-gradient(to right, transparent, rgba(30,144,255,.14), transparent)",
//           }}
//         />
//       </Box>
//     </>
//   );
// }

// import { Box, Container, Typography } from "@mui/material";
// import { motion } from "framer-motion";

// /* ───────────────── Fonts ───────────────── */
// const FontImport = () => (
//   <style>{`
//     @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
//   `}</style>
// );

// /* ───────────────── Data ───────────────── */
// const RECOGNITIONS = [
//   {
//     name: "Startup India",
//     tag: "Government Recognition",
//   },
//   {
//     name: "Startup Karnataka",
//     tag: "Innovation Ecosystem",
//   },
//   {
//     name: "Silicon India",
//     tag: "Media Recognition",
//   },
// ];

// /* ───────────────── Animation ───────────────── */
// const fadeUp = (delay = 0) => ({
//   initial: {
//     opacity: 0,
//     y: 20,
//   },

//   whileInView: {
//     opacity: 1,
//     y: 0,
//   },

//   viewport: {
//     once: true,
//   },

//   transition: {
//     duration: 0.65,
//     delay,
//     ease: [0.22, 1, 0.36, 1],
//   },
// });

// /* ───────────────── Main Component ───────────────── */
// export default function RecognizedBy() {
//   return (
//     <>
//       <FontImport />

//       <Box
//         component="section"
//         sx={{
//           position: "relative",
//           overflow: "hidden",
//           background: "#000000",

//           py: {
//             xs: 8,
//             sm: 10,
//             md: 14,
//             lg: 16,
//           },
//         }}
//       >
//         {/* top separator */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: "50%",
//             transform: "translateX(-50%)",

//             width: {
//               xs: "88%",
//               sm: "82%",
//               md: "60%",
//             },

//             height: "1px",

//             background:
//               "linear-gradient(to right, transparent, rgba(30,144,255,.18), transparent)",
//           }}
//         />

//         {/* ambient blue glow */}
//         <Box
//           component={motion.div}
//           animate={{
//             scale: [1, 1.08, 1],
//             opacity: [0.3, 0.6, 0.3],
//           }}
//           transition={{
//             duration: 7,
//             repeat: Infinity,
//             ease: "easeInOut",
//           }}
//           sx={{
//             position: "absolute",

//             width: {
//               xs: 180,
//               sm: 260,
//               md: 420,
//               lg: 520,
//             },

//             height: {
//               xs: 180,
//               sm: 260,
//               md: 420,
//               lg: 520,
//             },

//             borderRadius: "50%",

//             background:
//               "radial-gradient(circle, rgba(30,144,255,.12), transparent 70%)",

//             top: "-15%",
//             left: "50%",

//             transform:
//               "translateX(-50%)",

//             filter: {
//               xs: "blur(70px)",
//               md: "blur(90px)",
//             },

//             pointerEvents: "none",
//           }}
//         />

//         <Container
//           maxWidth="xl"
//           sx={{
//             position: "relative",
//             zIndex: 2,

//             px: {
//               xs: 2,
//               sm: 3,
//               md: 4,
//             },
//           }}
//         >
//           {/* heading */}
//           <Box
//             sx={{
//               textAlign: "center",

//               mb: {
//                 xs: 5,
//                 sm: 6,
//                 md: 8,
//               },
//             }}
//           >
//             {/* label */}
//             <motion.div {...fadeUp(0)}>
//               <Box
//                 sx={{
//                   display: "inline-flex",
//                   alignItems: "center",

//                   gap: {
//                     xs: 1,
//                     md: 1.2,
//                   },

//                   mb: {
//                     xs: 2.5,
//                     md: 3,
//                   },
//                 }}
//               >
//                 <Box
//                   sx={{
//                     width: {
//                       xs: 12,
//                       md: 18,
//                     },

//                     height: "1px",

//                     background:
//                       "rgba(30,144,255,.6)",
//                   }}
//                 />

//                 <Typography
//                   sx={{
//                     fontFamily:
//                       "'DM Sans', sans-serif",

//                     fontSize: {
//                       xs: ".6rem",
//                       sm: ".68rem",
//                       md: ".72rem",
//                     },

//                     fontWeight: 700,

//                     color:
//                       "rgba(88,178,255,.92)",

//                     letterSpacing: ".14em",

//                     textTransform:
//                       "uppercase",
//                   }}
//                 >
//                   Recognized By
//                 </Typography>

//                 <Box
//                   sx={{
//                     width: {
//                       xs: 12,
//                       md: 18,
//                     },

//                     height: "1px",

//                     background:
//                       "rgba(30,144,255,.6)",
//                   }}
//                 />
//               </Box>
//             </motion.div>

//             {/* heading */}
//             <motion.div {...fadeUp(0.08)}>
//               <Typography
//                 component="h2"
//                 sx={{
//                   fontFamily: "'Bricolage Grotesque', sans-serif",
//                   fontWeight: 750,
//                   fontSize: { xs: "1.9rem", sm: "2.4rem", md: "3rem" },
//                   lineHeight: 1.1,
//                   letterSpacing: { xs: "-1px", md: "-1.8px" },
//                   color: "rgba(255,255,255,.93)",
//                   mb: 2.5,
//                 }}
//               >
//                 Recognized across

//                 <br />

//                 <Box
//                   component="span"
//                   sx={{
//                     background:
//                       "#1E90FF",

//                     WebkitBackgroundClip:
//                       "text",

//                     WebkitTextFillColor:
//                       "transparent",
//                   }}
//                 >
//                   India’s innovation ecosystem
//                 </Box>
//               </Typography>
//             </motion.div>

//             {/* subtitle */}
//             <motion.div {...fadeUp(0.15)}>
//               <Typography
//                 sx={{
//                   maxWidth: {
//                     xs: "95%",
//                     sm: "88%",
//                     md: "700px",
//                   },

//                   mx: "auto",

//                   fontFamily:
//                     "'DM Sans', sans-serif",

//                   fontSize: {
//                     xs: ".9rem",
//                     sm: ".95rem",
//                     md: "1rem",
//                     lg: "1.05rem",
//                   },

//                   lineHeight: {
//                     xs: 1.8,
//                     md: 1.9,
//                   },

//                   color:
//                     "rgba(210,230,255,.7)",
//                 }}
//               >
//                 Supported and acknowledged by
//                 leading startup, innovation,
//                 and technology platforms driving
//                 next-generation entrepreneurship.
//               </Typography>
//             </motion.div>
//           </Box>

//           {/* recognition cards */}
//           <Box
//             sx={{
//               display: "grid",

//               gridTemplateColumns: {
//                 xs: "1fr",
//                 sm: "repeat(2,1fr)",
//                 lg: "repeat(3,1fr)",
//               },

//               gap: {
//                 xs: 2,
//                 sm: 2.5,
//                 md: 3,
//               },
//             }}
//           >
//             {RECOGNITIONS.map(
//               (item, index) => (
//                 <Box
//                   key={item.name}
//                   component={motion.div}
//                   initial={{
//                     opacity: 0,
//                     y: 20,
//                   }}
//                   whileInView={{
//                     opacity: 1,
//                     y: 0,
//                   }}
//                   viewport={{
//                     once: true,
//                   }}
//                   transition={{
//                     duration: 0.55,
//                     delay:
//                       index * 0.08,
//                   }}
//                   whileHover={{
//                     y: -4,
//                     scale: 1.02,
//                   }}
//                   sx={{
//                     position: "relative",

//                     overflow: "hidden",

//                     borderRadius: {
//                       xs: "18px",
//                       md: "22px",
//                     },

//                     p: {
//                       xs: 2.5,
//                       sm: 3,
//                       md: 4,
//                     },

//                     minHeight: {
//                       xs: 200,
//                       sm: 220,
//                       md: 240,
//                     },

//                     display: "flex",

//                     flexDirection:
//                       "column",

//                     justifyContent:
//                       "flex-end",

//                     background:
//                       "rgba(10,10,10,.92)",

//                     border:
//                       "1px solid rgba(30,144,255,.16)",

//                     backdropFilter:
//                       "blur(16px)",

//                     boxShadow:
//                       "inset 0 1px 0 rgba(255,255,255,.03)",

//                     transition:
//                       ".3s ease",

//                     "&:hover": {
//                       borderColor:
//                         "rgba(30,144,255,.35)",

//                       boxShadow:
//                         "0 10px 40px rgba(30,144,255,.15), inset 0 1px 0 rgba(255,255,255,.06)",
//                     },
//                   }}
//                 >
//                   {/* glow */}
//                   <Box
//                     sx={{
//                       position:
//                         "absolute",

//                       width: {
//                         xs: 110,
//                         md: 160,
//                       },

//                       height: {
//                         xs: 110,
//                         md: 160,
//                       },

//                       borderRadius:
//                         "50%",

//                       background:
//                         "radial-gradient(circle, rgba(30,144,255,.14), transparent 70%)",

//                       top: -80,
//                       right: -80,
//                     }}
//                   />

//                   {/* logo placeholder */}
//                   <Box
//                     sx={{
//                       width: {
//                         xs: 46,
//                         md: 52,
//                       },

//                       height: {
//                         xs: 46,
//                         md: 52,
//                       },

//                       borderRadius:
//                         "14px",

//                       display: "flex",

//                       alignItems:
//                         "center",

//                       justifyContent:
//                         "center",

//                       mb: {
//                         xs: 2,
//                         md: 3,
//                       },

//                       background:
//                         "rgba(30,144,255,.08)",

//                       border:
//                         "1px solid rgba(30,144,255,.2)",

//                       color:
//                         "#63B8FF",

//                       fontFamily:
//                         "'Bricolage Grotesque', sans-serif",

//                       fontWeight: 700,

//                       fontSize: {
//                         xs: ".9rem",
//                         md: "1rem",
//                       },
//                     }}
//                   >
//                     {item.name
//                       .split(" ")
//                       .map(
//                         (w) => w[0]
//                       )
//                       .join("")}
//                   </Box>

//                   {/* title */}
//                   <Typography
//                     sx={{
//                       fontFamily:
//                         "'Bricolage Grotesque', sans-serif",

//                       fontWeight: 700,

//                       color:
//                         "#FFFFFF",

//                       fontSize: {
//                         xs: ".95rem",
//                         sm: "1rem",
//                         md: "1.15rem",
//                       },

//                       lineHeight: 1.3,

//                       mb: 1.2,
//                     }}
//                   >
//                     {item.name}
//                   </Typography>

//                   {/* tag */}
//                   <Typography
//                     sx={{
//                       fontFamily:
//                         "'DM Sans', sans-serif",

//                       color:
//                         "rgba(210,230,255,.68)",

//                       fontSize: {
//                         xs: ".82rem",
//                         md: ".9rem",
//                       },

//                       lineHeight: 1.7,
//                     }}
//                   >
//                     {item.tag}
//                   </Typography>
//                 </Box>
//               )
//             )}
//           </Box>
//         </Container>

//         {/* bottom separator */}
//         <Box
//           sx={{
//             position: "absolute",
//             bottom: 0,
//             left: "50%",
//             transform: "translateX(-50%)",

//             width: {
//               xs: "88%",
//               sm: "82%",
//               md: "60%",
//             },

//             height: "1px",

//             background:
//               "linear-gradient(to right, transparent, rgba(30,144,255,.14), transparent)",
//           }}
//         />
//       </Box>
//     </>
//   );
// }

import { Box, Container, Typography } from "@mui/material";
import { Button } from "@mui/material";
import { motion } from "framer-motion";

/* ───────────────── Fonts ───────────────── */
const FontImport = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:wght@600;700;800&family=DM+Sans:wght@300;400;500;600;700&display=swap');
  `}</style>
);

/* ───────────────── Data ───────────────── */
const RECOGNITIONS = [
  {
    name: "Startup India",
    tag: "Government Recognition",
    logo: "/logos/startupindia.png",

    buttonText: "View Recognition",

    url: "https://recognition-be.startupindia.gov.in/s3/download/document/RECOGNITION_CERTIFICATE/4b32be77-1e45-4d03-b539-315ea21a4c55.pdf",
  },

  {
    name: "Startup Karnataka",
    tag: "Innovation Ecosystem",
    logo: "/logos/startupkarnataka.png",

    buttonText: "View Recognition",
    url: "/Startup_Karnataka_Registration.pdf",
  },

  {
    name: "Silicon India",
    tag: "Media Recognition",
    logo: "/logos/siliconindia.png",

    buttonText: "Read Feature",

    url: "https://startup.siliconindia.com/magazine/cover-feature/ai-startups-from-bangalore-2025-anthrasync-cid-26995.html",
  },
];

/* ───────────────── Animation ───────────────── */
const fadeUp = (delay = 0) => ({
  initial: {
    opacity: 0,
    y: 20,
  },

  whileInView: {
    opacity: 1,
    y: 0,
  },

  viewport: {
    once: true,
  },

  transition: {
    duration: 0.65,
    delay,
    ease: [0.22, 1, 0.36, 1],
  },
});

/* ───────────────── Main Component ───────────────── */
export default function RecognizedBy() {
  return (
    <>
      <FontImport />

      <Box
        component="section"
        sx={{
          position: "relative",
          overflow: "hidden",
          background: "#000000",

          py: {
            xs: 8,
            sm: 10,
            md: 14,
            lg: 16,
          },
        }}
      >
        {/* top separator */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",

            width: {
              xs: "88%",
              sm: "82%",
              md: "60%",
            },

            height: "1px",

            background:
              "linear-gradient(to right, transparent, rgba(30,144,255,.18), transparent)",
          }}
        />

        {/* ambient glow */}
        <Box
          component={motion.div}
          animate={{
            scale: [1, 1.08, 1],
            opacity: [0.3, 0.6, 0.3],
          }}
          transition={{
            duration: 7,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          sx={{
            position: "absolute",

            width: {
              xs: 180,
              sm: 260,
              md: 420,
              lg: 520,
            },

            height: {
              xs: 180,
              sm: 260,
              md: 420,
              lg: 520,
            },

            borderRadius: "50%",

            background:
              "radial-gradient(circle, rgba(30,144,255,.12), transparent 70%)",

            top: "-15%",
            left: "50%",

            transform:
              "translateX(-50%)",

            filter: {
              xs: "blur(70px)",
              md: "blur(90px)",
            },

            pointerEvents: "none",
          }}
        />

        <Container
          maxWidth="xl"
          sx={{
            position: "relative",
            zIndex: 2,

            px: {
              xs: 2,
              sm: 3,
              md: 4,
            },
          }}
        >
          {/* heading */}
          <Box
            sx={{
              textAlign: "center",

              mb: {
                xs: 5,
                sm: 6,
                md: 8,
              },
            }}
          >
            {/* label */}
            <motion.div {...fadeUp(0)}>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",

                  gap: {
                    xs: 1,
                    md: 1.2,
                  },

                  mb: {
                    xs: 2.5,
                    md: 3,
                  },
                }}
              >
                <Box
                  sx={{
                    width: {
                      xs: 12,
                      md: 18,
                    },

                    height: "1px",

                    background:
                      "rgba(30,144,255,.6)",
                  }}
                />

                <Typography
                  sx={{
                    fontFamily:
                      "'DM Sans', sans-serif",

                    fontSize: {
                      xs: ".6rem",
                      sm: ".68rem",
                      md: ".72rem",
                    },

                    fontWeight: 700,

                    color:
                      "rgba(88,178,255,.92)",

                    letterSpacing: ".14em",

                    textTransform:
                      "uppercase",
                  }}
                >
                  Recognized By
                </Typography>

                <Box
                  sx={{
                    width: {
                      xs: 12,
                      md: 18,
                    },

                    height: "1px",

                    background:
                      "rgba(30,144,255,.6)",
                  }}
                />
              </Box>
            </motion.div>

            {/* heading */}
            <motion.div {...fadeUp(0.08)}>
              <Typography
                component="h2"
                sx={{
                  fontFamily:
                    "'Bricolage Grotesque', sans-serif",

                  fontWeight: 800,

                  fontSize: {
                    xs: "2rem",
                    sm: "2.6rem",
                    md: "3.3rem",
                    lg: "4rem",
                  },

                  lineHeight: {
                    xs: 1.08,
                    md: 1.05,
                  },

                  letterSpacing: {
                    xs: "-1px",
                    md: "-2px",
                  },

                  color:
                    "rgba(255,255,255,.96)",

                  mb: 2.5,
                }}
              >
                Recognized across

                <br />

                <Box
                  component="span"
                  sx={{
                    color: "#1E90FF",
                  }}
                >
                  India’s innovation ecosystem
                </Box>
              </Typography>
            </motion.div>

            {/* subtitle */}
            <motion.div {...fadeUp(0.15)}>
              <Typography
                sx={{
                  maxWidth: {
                    xs: "95%",
                    sm: "88%",
                    md: "720px",
                  },

                  mx: "auto",

                  fontFamily:
                    "'DM Sans', sans-serif",

                  fontSize: {
                    xs: ".92rem",
                    sm: ".98rem",
                    md: "1.05rem",
                  },

                  lineHeight: {
                    xs: 1.8,
                    md: 1.9,
                  },

                  color:
                    "rgba(210,230,255,.68)",
                }}
              >
                Supported and acknowledged by
                leading startup, innovation,
                and technology platforms driving
                next-generation entrepreneurship
                and AI innovation in India.
              </Typography>
            </motion.div>
          </Box>

          {/* cards */}
          <Box
            sx={{
              display: "grid",

              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2,1fr)",
                lg: "repeat(3,1fr)",
              },

              gap: {
                xs: 2,
                sm: 2.5,
                md: 3,
              },
            }}
          >
            {RECOGNITIONS.map(
              (item, index) => (
                <Box
                  key={item.name}
                  component={motion.div}
                  initial={{
                    opacity: 0,
                    y: 20,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0,
                  }}
                  viewport={{
                    once: true,
                  }}
                  transition={{
                    duration: 0.55,
                    delay:
                      index * 0.08,
                  }}
                  whileHover={{
                    y: -5,
                    scale: 1.02,
                  }}
                  sx={{
                    position: "relative",

                    overflow: "hidden",

                    borderRadius: {
                      xs: "20px",
                      md: "24px",
                    },

                    p: {
                      xs: 3,
                      md: 4,
                    },

                    minHeight: {
                      xs: 220,
                      sm: 240,
                      md: 260,
                    },

                    display: "flex",

                    flexDirection:
                      "column",

                    justifyContent:
                      "flex-end",

                    background:
                      "rgba(8,8,8,.95)",

                    border:
                      "1px solid rgba(30,144,255,.14)",

                    backdropFilter:
                      "blur(18px)",

                    boxShadow:
                      "0 10px 40px rgba(0,0,0,.45)",

                    transition:
                      ".3s ease",

                    "&:hover": {
                      borderColor:
                        "rgba(30,144,255,.35)",

                      boxShadow:
                        "0 15px 50px rgba(30,144,255,.16)",
                    },
                  }}
                >
                  {/* glow */}
                  <Box
                    sx={{
                      position:
                        "absolute",

                      width: {
                        xs: 120,
                        md: 180,
                      },

                      height: {
                        xs: 120,
                        md: 180,
                      },

                      borderRadius:
                        "50%",

                      background:
                        "radial-gradient(circle, rgba(30,144,255,.16), transparent 70%)",

                      top: -90,
                      right: -90,

                      pointerEvents:
                        "none",
                    }}
                  />

                  {/* logo */}
                  <Box
                    sx={{
                      mb: {
                        xs: 2.5,
                        md: 3,
                      },

                      height: {
                        xs: 46,
                        md: 54,
                      },

                      display: "flex",

                      alignItems: "center",
                    }}
                  >
                    <Box
  component="img"
  src={item.logo}
  alt={item.name}
  sx={{
    maxWidth: {
      xs: 130,
      md: 170,
    },

    maxHeight: {
      xs: 42,
      md: 48,
    },

    width: "auto",
    height: "auto",

    objectFit: "contain",

    filter:
      item.name === "Silicon India"
        ? "brightness(1.3)"
        : "brightness(1.05)",

    /* ADD THIS */
    background:
      item.name === "Silicon India" ||
  item.name === "Startup Karnataka"
        ? "#ffffff"
        : "transparent",

    padding:
      item.name === "Silicon India" ||
  item.name === "Startup Karnataka"
        ? "6px 10px"
        : 0,

    borderRadius:
      item.name === "Silicon India" ||
  item.name === "Startup Karnataka"
        ? "10px"
        : 0,
  }}
/>
                  </Box>

                  {/* title */}
                  <Typography
                    sx={{
                      fontFamily:
                        "'Bricolage Grotesque', sans-serif",

                      fontWeight: 700,

                      color:
                        "#FFFFFF",

                      fontSize: {
                        xs: "1rem",
                        md: "1.15rem",
                      },

                      lineHeight: 1.3,

                      mb: 1.1,
                    }}
                  >
                    {item.name}
                  </Typography>

                  {/* tag */}
                  <Typography
                    sx={{
                      fontFamily:
                        "'DM Sans', sans-serif",

                      color:
                        "rgba(210,230,255,.65)",

                      fontSize: {
                        xs: ".84rem",
                        md: ".92rem",
                      },

                      lineHeight: 1.7,
                    }}
                  >
                    {item.tag}
                  </Typography>
                  <Button
  variant="contained"
  component={motion.a}
  whileHover={{
    scale: 1.03,
  }}
  whileTap={{
    scale: 0.98,
  }}
  href={item.url}
  target="_blank"
  sx={{
    mt: {
      xs: 2.5,
      md: 3,
    },

    width: "fit-content",

    alignSelf: "flex-start",

    background:
      "linear-gradient(90deg,#1E90FF 0%,#42A5FF 100%)",

    color: "#FFFFFF",

    textTransform: "none",

    fontFamily:
      "'DM Sans', sans-serif",

    fontWeight: 700,

    fontSize: {
      xs: ".82rem",
      md: ".88rem",
    },

    px: {
      xs: 2.2,
      md: 2.6,
    },

    py: {
      xs: .9,
      md: 1,
    },

    borderRadius: "12px",

    boxShadow:
      "0px 8px 25px rgba(30,144,255,.22)",

    border:
      "1px solid rgba(255,255,255,.08)",

    transition: ".25s ease",

    "&:hover": {
      background:
        "linear-gradient(90deg,#42A5FF 0%,#1E90FF 100%)",

      boxShadow:
        "0px 14px 35px rgba(30,144,255,.34)",
    },
  }}
>
  {item.buttonText}
</Button>
                </Box>
              )
            )}
          </Box>

          {/* CTA */}
{/* CTA Button */}

        </Container>

        {/* bottom separator */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform:
              "translateX(-50%)",

            width: {
              xs: "88%",
              sm: "82%",
              md: "60%",
            },

            height: "1px",

            background:
              "linear-gradient(to right, transparent, rgba(30,144,255,.14), transparent)",
          }}
        />
      </Box>
    </>
  );
}